
import { defineComponent, PropType } from 'vue';
import { PARKING_SORT_OPTIONS, FEATURE_FLAGS } from '@white-label-configuration/constants';
import { closeModal, popstateEventHandler, pushModalState } from '@white-label-helper/helper-history-modal';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import { initFeefoReviews, updateFeefoStyles } from '@white-label-helper/init-feefo-reviews';

export default defineComponent({
  name: 'SearchParkingSort',

  components: {
    IconArrowDown: () => import('@white-label-icon/icon-arrow-down'),
    IconButton: () => import('@white-label-icon/icon-button'),
    IconCheck: () => import('@white-label-icon/icon-check'),
    IconSort: () => import('@white-label-icon/icon-sort')
  },

  props: {
    sortOptions: {
      type: Array as PropType<string[]>,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      removePopstateHandler: null,
      listShown: false,
      PARKING_SORT_OPTIONS
    };
  },

  computed: {
    isScrollLocked(): boolean {
      return (this.isMobileResolution || this.isTabletResolution) && this.listShown;
    }
  },

  watch: {
    listShown: {
      handler(value) {
        if (!getFeatureFlag(FEATURE_FLAGS.CRO_887_BACK_MODALS_FUNCTIONALITY)) {
          return;
        }
        if (value) {
          pushModalState('sort');
        } else {
          closeModal();
        }
      }
    }
  },

  mounted() {
    if (getFeatureFlag(FEATURE_FLAGS.CRO_887_BACK_MODALS_FUNCTIONALITY)) {
      this.removePopstateHandler = popstateEventHandler('sort', () => this.listShown = false);
      this.listShown = window.location.hash?.includes('sort');
    }
  },

  beforeDestroy() {
    if (getFeatureFlag(FEATURE_FLAGS.CRO_887_BACK_MODALS_FUNCTIONALITY)) {
      if (this.removePopstateHandler) {
        this.removePopstateHandler();
      }
    }
  },

  methods: {
    onOptionSelect(option: string): void {
      this.$emit('input', option);
      this.listShown = false;

      initFeefoReviews();
      updateFeefoStyles();
    }
  }
});
